/*
 * Copyright 2026 Klyph Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

package xyz.hyli.klyph

fun ByteArray.toFnv1aHash(): UInt {
    var hash = 0x811C9DC5u // FNV offset basis
    val prime = 0x01000193u // FNV prime

    for (byte in this) {
        hash = hash xor byte.toUInt() // XOR with the current byte
        hash *= prime // Multiply by the FNV prime
    }

    return hash
}

fun String.toFnv1aHashString(): String =
    encodeToByteArray().toFnv1aHash().toString(16)
